import React from 'react';
import { Link } from 'react-router';
import { Button } from '../../../components/Button';
import { Section } from '../../../components/Section';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';

export const Hero: React.FC = () => {
    const { theme, breakpoint } = useTheme();
    const hero = megaGreenData.home.hero;

    return (
        <Section
            id="hero"
            style={{
                background: `linear-gradient(180deg, ${theme.background.panel} 0%, ${theme.background.default} 100%)`,
                position: 'relative',
                overflow: 'hidden',
                paddingTop: '100px',
                paddingBottom: '100px',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '-100px',
                    right: '-100px',
                    width: '400px',
                    height: '400px',
                    borderRadius: '50%',
                    background: `radial-gradient(circle, ${theme.palette.secondary.main} 0%, transparent 70%)`,
                    opacity: 0.1,
                    filter: 'blur(60px)',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: '-100px',
                    left: '-100px',
                    width: '400px',
                    height: '400px',
                    borderRadius: '50%',
                    background: `radial-gradient(circle, #684190 0%, transparent 70%)`,
                    opacity: 0.1,
                    filter: 'blur(60px)',
                }}
            />

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : '1fr 1fr',
                    gap: '48px',
                    alignItems: 'center',
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                <div>
                    <h1
                        style={{
                            fontSize: breakpoint.xs || breakpoint.sm ? '34px' : '42px',
                            fontWeight: 800,
                            color: theme.text.primary,
                            lineHeight: 1.35,
                            marginBottom: '20px',
                            letterSpacing: '-0.5px',
                        }}
                    >
                        {hero.h1}
                    </h1>

                    <p
                        style={{
                            fontSize: '18px',
                            color: theme.text.muted,
                            lineHeight: 1.6,
                            marginBottom: '32px',
                        }}
                    >
                        {hero.subhead}
                    </p>

                    <div
                        style={{
                            display: 'flex',
                            gap: '16px',
                            flexWrap: 'wrap',
                            marginBottom: '24px',
                        }}
                    >
                        <Link to={hero.primaryCTA.to} style={{ textDecoration: 'none' }}>
                            <Button variant="primary">
                                {hero.primaryCTA.label}
                            </Button>
                        </Link>
                        {hero.secondaryCTA && (
                            <Link to={hero.secondaryCTA.to} style={{ textDecoration: 'none' }}>
                                <Button variant="secondary">
                                    {hero.secondaryCTA.label}
                                </Button>
                            </Link>
                        )}
                    </div>

                    <p
                        style={{
                            fontSize: '14px',
                            color: theme.text.muted,
                            opacity: 0.8,
                        }}
                    >
                        Established {megaGreenData.site.establishedYear} • Environmental Consulting • Renewable Energy • Waste Management
                    </p>
                </div>

                <div>
                    <img src={hero.image.src} alt={hero.image.alt}
                        style={{
                            height: '420px',
                            borderRadius: '16px',
                            objectFit: 'cover'
                        }}
                    />
                </div>
            </div>
        </Section>
    );
};
